import { PageResponseVm } from 'api/core/page-response.vm';
import { CircuitVm } from './circuit.vm';
import { IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class GetCircuitsVm extends PageResponseVm<CircuitVm, string> {
    @IsString()
    nextOffset: string;

    @Type(() => CircuitVm)
    @ValidateNested({ each: true })
    objects: CircuitVm[];
}
